import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-layout',
    template: `
  <app-header></app-header>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
  `
})
export class LayoutComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

    ngAfterViewInit() {
      // let $lastScript = $('app-layout ng-component').last();
      // $lastScript.after(`<script type="text/javascript"> 
      // var DaumConversionDctSv="type=P,orderID=,amount="; 
      // var DaumConversionAccountID="c_VfxClZHoiBeSPJ2x88xQ00"; 
      // if(typeof DaumConversionScriptLoaded=="undefined"&&location.protocol!="file:"){ 
      // var DaumConversionScriptLoaded=true; 
      // document.write(unescape("%3Cscript%20type%3D%22text/javas"+"cript%22%20src%3D%22"+(location.protocol=="https:"?"https":"http")+"%3A//t1.daumcdn.net/cssjs/common/cts/vr200/dcts.js%22%3E%3C/script%3E")); 
      // } 
      // </script>`);
    }
}
declare var $: any;
